import pin_code_master from "../assests/images/master/pin-code-master.svg";
import pin_code_mapping from "../assests/images/master/pin-code-mapping.svg";
import packeting_guide from "../assests/images/master/packeting-guide.svg";
import sorting_guide from "../assests/images/master/sorting-guide.svg";
import rate_card from "../assests/images/master/rate-card.svg";
import route from "../assests/images/master/route.svg";
import tat from "../assests/images/master/tat.svg";
import other_setting from "../assests/images/master/other-setting.svg";
//import view_manifest from "../assests/images/master/view-manifest.svg";
// import cp_onboarding from "../assests/images/master/cp-onboarding.svg";
// import vehicle_onboard from "../assests/images/master/vehicle-onboard.svg";

export const parentMaster = [
  {
    id: 1,
    imgSrc: pin_code_master,
    title: "PIN code master",
    route: "/pincode-master",
    disable: false,
    childPresent: false,
  },
  {
    id: 2,
    imgSrc: pin_code_mapping,
    title: "PIN code mapping",
    route: "/pin-code-mapping",
    disable: false,
    childPresent: false,
  },
  {
    id: 3,
    imgSrc: packeting_guide,
    title: "packeting guide",
    route: "/packeting-guide",
    disable: false,
    childPresent: false,
  },
  {
    id: 4,
    imgSrc: sorting_guide,
    title: "sorting guide",
    route: "/sorting-guide",
    disable: false,
    childPresent: false,
  },
  {
    id: 5,
    imgSrc: rate_card,
    title: "rate card master",
    disable: false,
    childPresent: true,
  },
  {
    id: 6,
    imgSrc: route,
    title: "route master",
    route: "/route-configuration",
    disable: false,
    childPresent: false,
  },
  {
    id: 7,
    imgSrc: tat,
    title: "TAT master",
    disable: false,
    childPresent: true,
  },
  {
    id: 8,
    imgSrc: other_setting,
    title: "others setting",
    route: "",
    disable: true,
    childPresent: false,
  },
  // {
  //   id: 9,
  //   imgSrc: vehicle_onboard,
  //   title: "Vehicle onboard",
  //   route: "/vehicle-onboard",
  //   disable: false,
  //   childPresent: false,
  // },
  // {
  //   id: 10,
  //   imgSrc: cp_onboarding,
  //   title: "CP onboarding",
  //   route: "/cp-onbording",
  //   disable: false,
  //   childPresent: false,
  // },
  // {
  //   id: 9,
  //   imgSrc: view_manifest,
  //   title: "view manifest",
  //   route: "",
  //   disable: true,
  //   childPresent: false,
  // },
];
